module.exports = __webpack_public_path__ + "static/media/Cactus_IndigoFair-05.d22c8229.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/illustrations/Cactus_IndigoFair-05.png
 ** module id = 440
 ** module chunks = 0
 **/